import React, { useState } from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import LikutEntryModal from './likutEntry/LikutEntryModal'
import { AppModal } from '../../../../../generic/ui/Modal'
import { ScanBar } from '../../../../../generic/ui/Input'
import KbdChipButton from '../../../../../generic/ui/KbdChipButton/KbdChipButton'
import PackageBoxIcon from '../../../../../generic/icons/IconLib/PackageBoxIcon'
import PencilIcon from '../../../../../generic/icons/IconLib/PencilIcon'
import PlusIcon from '../../../../../generic/icons/IconLib/PlusIcon'
import { LINKS } from '../../../../../Routs/config'
import CustomBlockLoader from '../../knisot/generic/CustomBlockLoader'
import LocationForProduct from '../../warehouse/location/components/LocationForProduct'
import LikutPageLayout from '../Components/LikutPageLayout'
import LikutSectionHeader from './Components/LikutSectionHeader'
import ModalHeaderDetails from './Components/ModalHeaderDetails'
import LikutViewSelector, { TLikutView } from './Components/LikutViewSelector'
import LikutScrollArea from '../Components/LikutScrollArea'
import LikutGoodsListView from './Components/LikutGoodsListView'
import LikutSectionActionDock from './Components/LikutSectionActionDock'
import ModalArizot from './Components/ModalArizot'
import ModalManualProduct from './Components/ModalManualProduct'
import ModalCheckArizot from './Components/ModalCheckArizot'
import ModalRemark from './Components/ModalRemark'
import ModalAzmanaRows from './Components/ModalAzmanaRows'
import useLikutSection from './services/hooks/useLikutSection'

export const HeaderInformationWrapper = styled.div`
    background: #fdfdfd;
    /* height: 8em; */
    z-index: 2;
    border-radius: 30px;
    padding: 0.5em 1em;
    -webkit-box-shadow: -2px 8px 2px -6px rgba(41,127,118,0.71);
    box-shadow: -2px 8px 2px -6px rgba(41,127,118,0.71);
`
export const HeaderInformationInnerContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    /* background: #eff3f4; */
    border-radius: 25px;
    display: flex;

`
export const HeaderInformationInnerItem = styled.div<{ $primal?: boolean }>`
    height: 100%;
    width: ${props => props.$primal ? '30%' : '100%'};
    /* background: red; */
    direction: ltr;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: ${props => props.$primal ? 'flex-start' : 'flex-end'};
    gap: 0.5em;
`
export const HeaderInformationItem = styled.div<{ $primal?: boolean }>`
    /* background: blue; */
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 0.5em;
    color: #8a8aad;
    font-size: ${props => props.$primal ? '0.875rem' : '1rem'};
`
export const HeaderItemInfo = styled.div<{ $isGrow?: boolean }>`
    border: ${props => props.$isGrow ? '1px solid tomato' : 'none'};
    padding: ${props => props.$isGrow ? '0 0.5em' : '0'};
    border-radius: 10px;
    color: ${props => props.$isGrow ? 'tomato' : ''};
`

interface Props {
    getExistPalletInfo: (id: number) => Promise<any>;
    getPallet: (id?: number | null) => void;
    printPallet: (palletNum: number) => void;
    setPrintersModal: () => void;
    printerNum: number | string | null;
    numMishtah?: number | null;
    palletAzmana?: any[];
    activeArizotCalc?: boolean;
}

export default function LikutSectionMain({
    getExistPalletInfo, getPallet, printPallet, setPrintersModal,
    printerNum, numMishtah, palletAzmana, activeArizotCalc
}: Props) {
    const [t] = useTranslation(['likut', 'buttons']);
    const navigate = useNavigate();
    const [viewMode, setViewMode] = useState<TLikutView>('def');
    const [isOpenHeaderDetails, setIsOpenHeaderDetails] = useState(false);

    const {
        likutInfo,
        getToken,
        user,
        isOffice,
        Collect_Comm,
        packageList,
        defaultPackageList,
        activeResons,
        testForInitialPAcksOfAmount,
        artPass,
        deltaWeight,
        isWeightCalculation,
        isAddIdToDesc,
        isAllowMultipleSave,
        growersList,
        packageByCustomer,
        azmanotList,
        azmanotListDefault,
        existGoodsInPallet,
        isLoadingProductList,
        orderTitle,
        persents,
        progressColor,
        existArizotQty,
        existWeigthQty,
        goodsCode,
        setGoodsCode,
        entryInformation,
        getGoodsInfoEntry,
        likutModalToggle,
        setLikutModalToggle,
        defaultPacks,
        setDefaultPacks,
        packageType,
        setPackageType,
        isAllowManualProductAdd,
        isOpenManualProductModal,
        handleControlManualProductModal,
        handleManualProductSubmit,
        selectAzmanaRowModal,
        setSelectAzmanaRowModal,
        selectedProduct,
        isOpenProductLocationModal,
        handleControlProductLocationModal,
        handleOpenProductLocationModal,
        isOpenArizotModal,
        setIsOpenArizotModal,
        isOpenRemarkModal,
        setIsOpenRemarkModal,
        isOpenProductRemarkModal,
        handleProductRemarkModal,
        remarkState,
        isOpenCheckArizot,
        setIsOpenCheckArizot,
        recID,
        setRecID,
        selectGoodForLikut,
        deleteItemFromPallet,
        editOrderRow,
        handleSelectOrderLine,
        isSelectedProduct,
        multipleSaveRequest,
        handleSave,
        savePallet,
        saveArizotRequest,
        saveCheckedPalletInfo,
        checkGivenPacks,
        getAzmanotDetailes,
        updateExistPallets,
        checkForSiumLikut,
        errAlert,
        selectFunc,
        setInputFocus,
    } = useLikutSection({ getExistPalletInfo, getPallet, printPallet, setPrintersModal, printerNum })

    const likutModalWindow = likutModalToggle ?
        <LikutEntryModal
            setLikutModalToggle={setLikutModalToggle}
            goodsCode={goodsCode}
            entryInformation={entryInformation[0]}
            azmanotListDefault={azmanotListDefault}
            defaultPacks={defaultPacks}
            setDefaultPacks={setDefaultPacks}
            likutInfo={likutInfo}
            getToken={getToken}
            updateExistPallets={updateExistPallets}
            getAzmanotDetailes={getAzmanotDetailes}
            setInputFocus={setInputFocus}
            defaultPackageList={defaultPackageList}
            packageType={packageType}
            checkForSiumLikut={checkForSiumLikut}
            errAlert={errAlert}
            orderTitle={orderTitle}
            activeResons={activeResons}
            user={user}
            persents={persents}
            isWeightCalculation={isWeightCalculation}
            testForInitialPAcksOfAmount={testForInitialPAcksOfAmount}
            growersList={growersList?.growers || []}

        />
        :
        ''

    const closeRowsModal = () => {
        setSelectAzmanaRowModal(false)
    }

    const handleViewSelect = (value: TLikutView) => {
        setViewMode(value)
        selectFunc(value)
    }

    const dockLabel = isSelectedProduct
        ? t("likut_sectionmain_multiplesave_button")
        : t("save", { ns: "buttons" })

    const handleDockClick = () => {
        if (isSelectedProduct) {
            multipleSaveRequest()
            return
        }
        if (activeArizotCalc && (likutInfo?.isNewPallet || likutInfo.azmanaStatus !== 7)) {
            setIsOpenCheckArizot(true)
            return
        }
        handleSave()
        navigate(LINKS.likut.likutExperess.palletSection)
    }

    return (
        <LikutPageLayout title={
            likutInfo?.pallet?.palletNum !== 999999 ?
                t('likut_sectionmain_title_withpallet', { pallet: `${+(numMishtah as number) || (palletAzmana?.length ?? 0) + 1} (${likutInfo?.pallet?.palletNum})` })
                : t('likut_sectionmain_title_new')
        }>
            {likutModalWindow}
            {
                isOpenCheckArizot &&
                <AppModal
                    title={t('likut_modal_checkpallet_title')}
                    controlFunc={() => { setIsOpenCheckArizot(!isOpenCheckArizot) }}
                    Children={ModalCheckArizot}
                    childrenProps={{
                        packQty: checkGivenPacks,
                        saveFunc: savePallet,
                        delta: deltaWeight,
                        saveCheckedPalletInfo: saveCheckedPalletInfo,
                        likutInfo: likutInfo,
                        artPass: artPass,
                        palletDetails: existGoodsInPallet,
                    }}
                    size='sm'
                    disableOutsideClick
                />
            }
            {
                isOpenProductLocationModal &&
                <AppModal
                    title={selectedProduct?.Desc || ''}
                    controlFunc={handleControlProductLocationModal}
                    Children={LocationForProduct}
                    childrenProps={{
                        productID: selectedProduct?.ProductID || 0,
                        varietyID: selectedProduct?.VarietyID || 0,
                        sizeID: selectedProduct?.SizeID || '',
                        packID: selectedProduct?.PackID || 0,
                        onSelectEntry: (entryCode: string) => {
                            handleControlProductLocationModal()
                            getGoodsInfoEntry(entryCode)
                        },
                    }}
                    size='md'
                />
            }
            {
                isOpenProductRemarkModal &&
                <AppModal
                    title={t('likut_modal_remarks_title')}
                    controlFunc={handleProductRemarkModal}
                    Children={ModalRemark}
                    childrenProps={{ text: remarkState.remark }}
                    size='sm'
                />
            }
            {
                isOpenRemarkModal &&
                <AppModal
                    title={t('likut_modal_remarks_title')}
                    controlFunc={() => { setIsOpenRemarkModal(!isOpenRemarkModal) }}
                    Children={ModalRemark}
                    childrenProps={{ text: Collect_Comm }}
                    size='sm'
                />
            }
            {
                selectAzmanaRowModal &&
                <AppModal
                    title={t('likut_modal_select_product_title')}
                    controlFunc={closeRowsModal}
                    Children={ModalAzmanaRows}
                    childrenProps={{
                        azmanotListDefault,
                        defaultPackageList,
                        entryLine: entryInformation[0],
                        isWeightCalculation,
                        isAddIdToDesc,
                        isOffice,
                        recID,
                        setRecID,
                        setGoodsCode,
                        editOrderRow,
                        selectGoodForLikut,
                        handleSelectOrderLine,
                        handleOpenProductLocationModal,
                    }}
                    size='md'
                />
            }
            {
                isOpenArizotModal &&
                <AppModal
                    title={t('likut_modal_addpackage_title')}
                    controlFunc={() => { setIsOpenArizotModal(!isOpenArizotModal) }}
                    Children={ModalArizot}
                    childrenProps={{
                        list: packageByCustomer?.Data?.length > 0 ? packageByCustomer.Data : packageList,
                        defaultID: packageByCustomer?.DefaultID || 0,
                        saveFunc: saveArizotRequest,
                    }}
                    size='sm'
                />
            }
            {
                isOpenManualProductModal &&
                <AppModal
                    title={t('likut_modal_manual_product_title')}
                    controlFunc={handleControlManualProductModal}
                    Children={ModalManualProduct}
                    childrenProps={{
                        packageList: defaultPackageList ?? [],
                        onSubmit: handleManualProductSubmit,
                    }}
                    size='sm'
                />
            }
            {
                isOpenHeaderDetails &&
                <AppModal
                    title={t('likut_modal_order_details_title')}
                    controlFunc={() => setIsOpenHeaderDetails(false)}
                    Children={ModalHeaderDetails}
                    childrenProps={{ orderTitle, likutInfo, collectComm: Collect_Comm }}
                    size='sm'
                />
            }

            <LikutScrollArea
                scrollHeader={
                    <>
                        <LikutSectionHeader
                            likutInfo={likutInfo}
                            isAddIdToDesc={isAddIdToDesc}
                            persents={persents}
                            progressColor={progressColor}
                            existWeigthQty={existWeigthQty}
                            existArizotQty={existArizotQty}
                            onOpenDetails={() => setIsOpenHeaderDetails(true)}
                        />
                        <FilterRow>
                            <SelectorShell>
                                <LikutViewSelector value={viewMode} onSelect={handleViewSelect} />
                            </SelectorShell>
                            {
                                likutInfo?.pallet?.palletNum !== 999999 && (
                                    <KbdChipButton
                                        onClick={() => { setIsOpenArizotModal(!isOpenArizotModal) }}
                                        aria-label={t('likut_modal_addpackage_title')}
                                        title={t('likut_modal_addpackage_title')}
                                    >
                                        <PackageBoxIcon size={16} color='currentColor' />
                                    </KbdChipButton>
                                )
                            }
                            {
                                Collect_Comm?.trim() && (
                                    <KbdChipButton
                                        onClick={() => { setIsOpenRemarkModal(!isOpenRemarkModal) }}
                                        aria-label={t('likut_modal_remarks_title')}
                                        title={t('likut_modal_remarks_title')}
                                    >
                                        <PencilIcon size={16} color='currentColor' />
                                    </KbdChipButton>
                                )
                            }
                        </FilterRow>
                    </>
                }
                stickyHeader={
                    <StickyRow>
                        <ScanSlot>
                            <ScanBar
                                value={goodsCode}
                                onChange={setGoodsCode}
                                onScan={(value) => getGoodsInfoEntry(value)}
                                captureGlobalScans={false}
                                blurOnSubmit
                                placeholder={t('likut_sectionmain_scan_placeholder')}
                            />
                        </ScanSlot>
                        {
                            isAllowManualProductAdd && (
                                <KbdChipButton
                                    onClick={handleControlManualProductModal}
                                    aria-label={t('likut_modal_manual_product_title')}
                                    title={t('likut_modal_manual_product_title')}
                                >
                                    <PlusIcon size={16} color='currentColor' />
                                </KbdChipButton>
                            )
                        }
                    </StickyRow>
                }
            >
                {
                    isLoadingProductList ?
                        <CustomBlockLoader />
                        :
                        <LikutGoodsListView
                            azmanotList={azmanotList}
                            existGoodsInPallet={existGoodsInPallet}
                            defaultPackageList={defaultPackageList}
                            isWeightCalculation={!!isWeightCalculation}
                            isAddIdToDesc={!!isAddIdToDesc}
                            isOffice={!!isOffice}
                            isAllowMultipleSave={!!isAllowMultipleSave}
                            recID={recID}
                            setRecID={setRecID}
                            setGoodsCode={setGoodsCode}
                            editOrderRow={editOrderRow}
                            selectGoodForLikut={selectGoodForLikut}
                            handleSelectOrderLine={handleSelectOrderLine}
                            handleOpenProductLocationModal={handleOpenProductLocationModal}
                            setDefaultPacks={setDefaultPacks}
                            deleteFromPallet={deleteItemFromPallet}
                        />
                }
            </LikutScrollArea>
            {
                likutInfo?.pallet?.palletNum !== 999999 && (
                    <LikutSectionActionDock
                        label={dockLabel}
                        onClick={handleDockClick}
                    />
                )
            }
        </LikutPageLayout>
    )
}

const StickyRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    direction: rtl;
`;

// Scrolls away together with the section header — only the scan bar stays sticky.
const FilterRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    direction: rtl;
    margin-top: 0.625rem;
    padding: 0 0.25rem;
`;

const ScanSlot = styled.div`
    flex: 1;
    min-width: 0;
`;

const SelectorShell = styled.div`
    flex-shrink: 0;
    width: 9.5rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 8rem;
    }
`;
